import React, { useMemo } from "react";
import { ColumnDuration, PlannerRights, TimelineMode } from "src/components/Planner/types";
import TimelineColumnDay from "./TimelineColumnDay";
import TimelineColumnWeek from "./TimelineColumnWeek";
import TimelineColumnMonth from "./TimelineColumnMonth";
import TimelineColumnQuarter from "./TimelineColumnQuarter";
import "./TimelineColumn.scss";

export interface ITimelineColumnProps {
    item: ColumnDuration;
    columnIndex: number;
    columnWidth: number;
    timelineMode: TimelineMode;
    label?: Spintr.PlannerLabel;
    displayLabelRow: boolean;
    reportHeaderHeight: (height: number) => void;
    rights: PlannerRights;
}

const TimelineColumn = (props: ITimelineColumnProps) => {
    const column = useMemo(() => {
        switch (props.timelineMode) {
            case "DAYS":
                return <TimelineColumnDay {...props} />
            case "WEEKS":
                return <TimelineColumnWeek {...props} />
            case "MONTHS":
                return <TimelineColumnMonth {...props} />
            default:
                return <TimelineColumnQuarter {...props} />
        }
    }, [props.timelineMode, props.item, props.label, props.displayLabelRow]);

    return column;
}

export default TimelineColumn;
